import { render, staticRenderFns } from "./EventAttendees.vue?vue&type=template&id=0a8b9855&scoped=true&"
import script from "./EventAttendees.vue?vue&type=script&lang=js&"
export * from "./EventAttendees.vue?vue&type=script&lang=js&"
import style0 from "./EventAttendees.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EventAttendees.vue?vue&type=style&index=1&id=0a8b9855&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b9855",
  null
  
)

export default component.exports